document.addEventListener("DOMContentLoaded", () => {
    const interval = setInterval(() => {
        const foreign = document.querySelector(".gta-timer__svg foreignObject");

        if (!foreign) return; // pas encore chargé

        const innerDoc = foreign.firstElementChild; // <div> interne
        if (!innerDoc) return;

        const h4s = innerDoc.querySelectorAll("h4");
        if (h4s.length === 0) return;

        h4s.forEach(h4 => {
            const div = document.createElement("div");

            for (const attr of h4.attributes) {
                div.setAttribute(attr.name, attr.value);
            }

            div.innerHTML = h4.innerHTML;
            h4.parentNode.replaceChild(div, h4);
        });

        clearInterval(interval);
        console.log("✔️ H4 remplacés dans foreignObject");
    }, 200);
});
